export const LOCAL_STORAGE_AUTH_TOKEN = 'petis_owner_auth_token'
